module.exports = "../static/images/38cea4.png";